import { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  Dialog,
  DialogContent,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseManageConsultants } from "./UseManageConsultants";
import { useNavigate, useLocation } from "react-router-dom";
import { removeComma, toMoney } from "../../util/Utils";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import useBreakpoints from "../../hooks/useBreakpoints";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import SearchComOff from "../../ContentManagement/firstPage/HomeOffer/SearchComOff";

export default function AddConsultantClients(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, findClients, AddClients } = UseManageConsultants();
  const [open, setOpen] = useState({ show: false, count: undefined });
  const [name, setName] = useState("");
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const { isSmall } = useBreakpoints();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [state, setState] = useState({
    consulatorID:
      location.state && location.state.id ? location.state.id : undefined,
    top: 100,
    productID: undefined,
    brandID: undefined,
    start: undefined,
    end: undefined,
  });

  const [errorState, setErrorState] = useState({
    top: false,
    productID: false,
    brandID: false,
    start: false,
    end: false,
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      setState({ ...state, consulatorID: location.state.id });
    }
  }, [location.state]);

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, start: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, end: newValueEnd });
  }, [valueEnd]);

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/manageconsulate" },
          { name: "افزودن مشتری", url: "/manageconsulate/addClient" },
        ],
      }}
    >
      <Box display="grid" gap={3}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 7"}
          >
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={valueStart}
              onChange={setValueStart}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="از تاریخ"
                  error={errorState.start}
                />
              }
            />
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={valueEnd}
              onChange={setValueEnd}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  label="تا تاریخ"
                  size="small"
                  fullWidth
                  error={errorState.end}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 10"}
          >
            <SearchComOff
              sell
              article={isSmall ? true : false}
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
              validation={errorState.productID}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 2"></Box>}
          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 5"}
          >
            <BrandSearchCom
              setName={setName}
              validation={errorState.brandID}
              selectedBrandID={state.brandID}
              setter={setState}
              lvl1State={state}
            ></BrandSearchCom>
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 2"}
          >
            <TextField
              fullWidth
              value={state.top ? toMoney(state.top) : ""}
              label="تعداد"
              sx={{
                // width: isSmall ? "100%" : "75%",
                input: { textAlign: "center" },
              }}
              size="small"
              variant="outlined"
              error={errorState.top}
              onKeyDown={(e) => {
                exceptThisSymbols.includes(e.key) && e.preventDefault();
              }}
              onChange={(event, value) => {
                if (event.target.value) {
                  const sanitizedValue = event.target.value.replace(
                    /[^0-9.]/g,
                    ""
                  );
                  setState({
                    ...state,
                    top: removeComma(Number(sanitizedValue)),
                  });
                } else {
                  setState({
                    ...state,
                    top: undefined,
                  });
                }
              }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  min: 1,
                },
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
            gridColumn="span 12"
          >
            <Button
              variant="contained"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  findClients(state, (callback) => {
                    setOpen({ show: true, count: callback });
                  });
                }
              }}
            >
              یافتن
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/manageconsulate", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      </Box>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpen({ show: false, count: undefined });
        }}
        open={open.show}
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{ my: 2, display: "flex", alignItems: "center" }}>
              <Typography sx={{ mr: 1 }} variant="body1">
                تعداد
              </Typography>
              <Typography sx={{ mx: 1 }} color="secondary.main" variant="body1">
                {open.show && open.count ? open.count : ""}
              </Typography>
              <Typography sx={{ mr: 1 }} variant="body1">
                مشتری یافت شد
              </Typography>
            </Box>
            <Typography sx={{ mb: 2 }} variant="body2">
              آیا از افزودن اطمینان دارید؟
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                variant="contained"
                onClick={() => {
                  setProgress(true);
                  AddClients(state, () => {
                    setOpen({ show: false, count: undefined });
                    setState({
                      ...state,
                      productID: undefined,
                      brandID: undefined,
                    });
                    // navigate("/manageconsulate", {
                    //   state: { ...location.state, isBack: true },
                    //   replace: true,
                    // });
                  });
                }}
              >
                افزودن
              </Button>
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setOpen({ show: false, count: undefined });
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
